import { render, staticRenderFns } from "./OrderListOrder.vue?vue&type=template&id=32f72f40&scoped=true"
import script from "./OrderListOrder.vue?vue&type=script&lang=js"
export * from "./OrderListOrder.vue?vue&type=script&lang=js"
import style0 from "./OrderListOrder.vue?vue&type=style&index=0&id=32f72f40&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f72f40",
  null
  
)

export default component.exports